import script from "./AppContent.vue?vue&type=script&setup=true&lang=js"
export * from "./AppContent.vue?vue&type=script&setup=true&lang=js"

import "./AppContent.vue?vue&type=style&index=0&id=0f67bd8c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f67bd8c"]])

export default __exports__